import React from "react";

import Information from "./components/information";
import ApplicationInfo from "./components/applicationInfo";
import Offer from "./components/offer";
import OfferProperty from "./components/offerProperty";
import NotifyOwner from "./components/notifyOwner";
import Inspections from "./components/inspections";
import PropertyAccepted from "./components/propertyAccepted";
import MoveinPrep from "./components/moveinPrep";
import AfterMovein from "./components/afterMoveIn";
import Info from "./components/info";
import InspectProperty from "./components/inspectProperty";
import StaffToInspect from "./components/staffToInspect";
import SetupTenant from "./components/setupTenant";
import CancelShowing from "./components/cancelShowings";
import SendWelcomeEmail from "./components/sendWelcomeEmail";
import EndLawnCare from "./components/endLawnCare";
import EndUtilities from "./components/endUtilities";
import VerifyProratedRentPaid from "./components/verifyProratedRentPaid";
import AddTenantTags from "./components/addTenantTags";
import SendMoveinCode from "./components/sendMoveinCode";
import CodeboxPickup from "./components/codeboxPickup";
import MoveInCancelled from "./components/moveInCancelled";
import CompleteMovein from "./components/completeMovein";
import FAQLinks from "./components/FAQLinks";

const MoveIn = ({ itemId, listId, checkedItems }) => {
  return (
    <div>
      {itemId === 1 && (
        <Information
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 2 && (
        <ApplicationInfo
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 3 && (
        <Offer itemId={itemId} listId={listId} checkedItems={checkedItems} />
      )}
      {itemId === 4 && (
        <OfferProperty
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 5 && (
        <NotifyOwner
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 6 && (
        <Inspections
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 7 && (
        <InspectProperty
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 8 && (
        <StaffToInspect
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 9 && (
        <PropertyAccepted
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 10 && (
        <CancelShowing
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 11 && (
        <SetupTenant
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 12 && (
        <SendWelcomeEmail
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 13 && (
        <MoveinPrep
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 14 && (
        <EndLawnCare
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 15 && (
        <EndUtilities
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 16 && (
        <VerifyProratedRentPaid
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 17 && (
        <AddTenantTags
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 18 && (
        <SendMoveinCode
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 19 && (
        <AfterMovein
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 20 && (
        <CodeboxPickup
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 21 && (
        <MoveInCancelled
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 22 && (
        <CompleteMovein
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 23 && (
        <Info itemId={itemId} listId={listId} checkedItems={checkedItems} />
      )}
      {itemId === 24 && (
        <FAQLinks itemId={itemId} listId={listId} checkedItems={checkedItems} />
      )}
    </div>
  );
};

export default MoveIn;
